import React from "react";

import FormInput from "../../../../common/forms/FormInput";

import { ValType } from "../../../../utils/ValidationFunctions";

import styles from "../EditBase.module.scss";
import ChannelURLHelper from "./ChannelURLHelper";

type Props = {
  handleInputChange: (value: File | string | undefined, name: string) => void;
  twitter?: string;
  twitch?: string;
  instagram?: string;
  facebook?: string;
  youtube?: string;
};

const EditSNS: React.FC<Props> = ({
  handleInputChange,
  twitter,
  twitch,
  instagram,
  facebook,
  youtube,
}) => {
  return (
    <div className={styles["p-edit__wrapper"]}>
      <div className={styles["p-edit__inner"]}>
        <div className={styles["p-edit__title"]}>SNS情報</div>
        <div className={styles["p-edit__form"]}>
          <FormInput
            type="text"
            label="X (旧Twitter)"
            label_class={styles["p-edit__form-title"]}
            id="twitter"
            name="sonic_twitter"
            placeholder="URLを入力"
            initial_value={twitter}
            style_class={styles["p-edit__form-input"]}
            handler={handleInputChange}
            val_type={ValType.Twitter}
          />
        </div>
        <div className={styles["p-edit__form"]}>
          <FormInput
            type="text"
            label="Instagram"
            label_class={styles["p-edit__form-title"]}
            id="instagram"
            name="sonic_instagram"
            placeholder="URLを入力"
            initial_value={instagram}
            style_class={styles["p-edit__form-input"]}
            handler={handleInputChange}
            val_type={ValType.Instagram}
          />
        </div>
        <div className={styles["p-edit__form"]}>
          <FormInput
            type="text"
            label="Facebook"
            label_class={styles["p-edit__form-title"]}
            id="facebook"
            name="sonic_facebook"
            placeholder="URLを入力"
            initial_value={facebook}
            style_class={styles["p-edit__form-input"]}
            handler={handleInputChange}
            val_type={ValType.Facebook}
          />
        </div>
        <div className={`${styles["p-edit__form"]} ${styles["youtube"]}`}>
          <FormInput
            type="text"
            label="YouTubeチャンネル"
            label_class={styles["p-edit__form-title"]}
            id="youtube"
            name="sonic_youtube"
            placeholder="https://youtube.com/channel/チャンネルID"
            initial_value={youtube ? youtube : "https://youtube.com/channel/"}
            style_class={styles["p-edit__form-input"]}
            handler={handleInputChange}
            val_type={ValType.Youtube}
            label_supplement={<ChannelURLHelper />}
          />
        </div>
        <div className={styles["p-edit__form"]}>
          <FormInput
            type="text"
            label="Twitchチャンネル"
            label_class={styles["p-edit__form-title"]}
            id="twitch"
            name="sonic_twitch"
            placeholder="URLを入力"
            initial_value={twitch}
            style_class={styles["p-edit__form-input"]}
            handler={handleInputChange}
            val_type={ValType.Twitch}
          />
        </div>
      </div>
    </div>
  );
};

export default EditSNS;
